export default {
    access_point_established: {
        name: "Access Point Established",
        url: "fireai_au/access_point_established",
    },
    access_point_planned: {
        name: "Access Point Planned",
        url: "fireai_au/access_point_planned",
    },
    airbase_established: {
        name: "Airbase Established",
        url: "fireai_au/airbase_established",
    },
    airbase_planned: {
        name: "Airbase Planned",
        url: "fireai_au/airbase_planned",
    },
    ambulance_established_location: {
        name: "Ambulance Established Location",
        url: "fireai_au/ambulance_established_location",
    },
    ambulance_planned_location: {
        name: "Ambulance Planned Location",
        url: "fireai_au/ambulance_planned_location",
    },
    animal_shelter_established: {
        name: "Animal Shelter Established",
        url: "fireai_au/animal_shelter_established",
    },
    animal_shelter_planned: {
        name: "Animal Shelter Planned",
        url: "fireai_au/animal_shelter_planned",
    },
    assembly_area_established: {
        name: "Assembly Area Established",
        url: "fireai_au/assembly_area_established",
    },
    assembly_area_planned: {
        name: "Assembly Area Planned",
        url: "fireai_au/assembly_area_planned",
    },
    base_camp_established: {
        name: "Base Camp Established",
        url: "fireai_au/base_camp_established",
    },
    base_camp_planned: {
        name: "Base Camp Planned",
        url: "fireai_au/base_camp_planned",
    },
    control_centre_established: {
        name: "Control Centre Established",
        url: "fireai_au/control_centre_established",
    },
    control_centre_planned: {
        name: "Control Centre Planned",
        url: "fireai_au/control_centre_planned",
    },
    decontamination_site: {
        name: "Decontamination Site",
        url: "fireai_au/decontamination_site",
    },
    evacuation_centre_established: {
        name: "Evacuation Centre Established",
        url: "fireai_au/evacuation_centre_established",
    },
    evacuation_centre_planned: {
        name: "Evacuation Centre Planned",
        url: "fireai_au/evacuation_centre_planned",
    },
    fire_appliance: {
        name: "Fire Appliance",
        url: "fireai_au/fire_appliance",
    },
    fire_appliance_planned: {
        name: "Fire Appliance Planned",
        url: "fireai_au/fire_appliance_planned",
    },
    fire_point_of_origin_confirmed: {
        name: "Fire Point of Origin Confirmed",
        url: "fireai_au/fire_point_of_origin_confirmed",
    },
    fire_point_of_origin_unconfirmed: {
        name: "Fire Point of Origin Unconfirmed",
        url: "fireai_au/fire_point_of_origin_unconfirmed",
    },
    flood_rescue_boat_confirmed: {
        name: "Flood Rescue Boat Confirmed",
        url: "fireai_au/flood_rescue_boat_confirmed",
    },
    flood_rescue_boat_unconfirmed: {
        name: "Flood Rescue Boat Unconfirmed",
        url: "fireai_au/flood_rescue_boat_unconfirmed",
    },
    forward_operating_base: {
        name: "Forward Operating Base",
        url: "fireai_au/forward_operating_base",
    },
    helibase_established: {
        name: "Helibase Established",
        url: "fireai_au/helibase_established",
    },
    helibase_planned: {
        name: "Helibase Planned",
        url: "fireai_au/helibase_planned",
    },
    helipad_established: {
        name: "Helipad Established",
        url: "fireai_au/helipad_established",
    },
    helipad_planned: {
        name: "Helipad Planned",
        url: "fireai_au/helipad_planned",
    },
    hydrant: {
        name: "Hydrant",
        url: "fireai_au/hydrant",
    },
    medical_established: {
        name: "Medical Established",
        url: "fireai_au/medical_established",
    },
    medical_planned: {
        name: "Medical Planned",
        url: "fireai_au/medical_planned",
    },
    point_of_interest: {
        name: "Point of Interest",
        url: "fireai_au/point_of_interest",
    },
    police_vehicle_established: {
        name: "Police Vehicle Established",
        url: "fireai_au/police_vehicle_established",
    },
    police_vehicle_planned: {
        name: "Police Vehicle Planned",
        url: "fireai_au/police_vehicle_planned",
    },
    portable_communications_installation: {
        name: "Portable Communications Installation",
        url: "fireai_au/portable_communications_installation",
    },
    remote_access_fire_team: {
        name: "Remote Access Fire Team",
        url: "fireai_au/remote_access_fire_team",
    },
    road_closure_traffic_control_point_active: {
        name: "Road Closure Traffic Control Point Active",
        url: "fireai_au/road_closure_traffic_control_point_active",
    },
    road_closure_traffic_control_point_planned: {
        name: "Road Closure Traffic Control Point Planned",
        url: "fireai_au/road_closure_traffic_control_point_planned",
    },
    ses_vehicle_established: {
        name: "SES Vehicle Established",
        url: "fireai_au/ses_vehicle_established",
    },
    ses_vehicle_planned: {
        name: "SES Vehicle Planned",
        url: "fireai_au/ses_vehicle_planned",
    },
    sector_command: {
        name: "Sector Command",
        url: "fireai_au/sector_command",
    },
    sector_command_planned: {
        name: "Sector Command Planned",
        url: "fireai_au/sector_command_planned",
    },
    skimmer_deployed: {
        name: "Skimmer Deployed",
        url: "fireai_au/skimmer_deployed",
    },
    skimmer_planned: {
        name: "Skimmer Planned",
        url: "fireai_au/skimmer_planned",
    },
    staging: {
        name: "Staging",
        url: "fireai_au/staging",
    },
    staging_planned: {
        name: "Staging Planned",
        url: "fireai_au/staging_planned",
    },
    temporary_waste_disposal_site: {
        name: "Temporary Waste Disposal Site",
        url: "fireai_au/temporary_waste_disposal_site",
    },
    temporary_waste_disposal_site_planned: {
        name: "Temporary Waste Disposal Site Planned",
        url: "fireai_au/temporary_waste_disposal_site_planned",
    },
    tree_down_confirmed: {
        name: "Tree Down Confirmed",
        url: "fireai_au/tree_down_confirmed",
    },
    tree_down_unconfirmed: {
        name: "Tree Down Unconfirmed",
        url: "fireai_au/tree_down_unconfirmed",
    },
    water_point: {
        name: "Water Point",
        url: "fireai_au/water_point",
    },
    water_point_vehicle: {
        name: "Water Point Vehicle",
        url: "fireai_au/water_point_vehicle",
    },
    weather_station: {
        name: "Weather Station",
        url: "fireai_au/weather_station",
    },
    weather_station_planned: {
        name: "Weather Station Planned",
        url: "fireai_au/weather_station_planned",
    },
    wildlife_response_centre: {
        name: "Wildlife Response Centre",
        url: "fireai_au/wildlife_response_centre",
    },
    wildlife_response_centre_planned: {
        name: "Wildlife Response Centre Planned",
        url: "fireai_au/wildlife_response_centre_planned",
    },
}
